import React from 'react';
import {Button, Col, Container, Modal, Pagination, Row, Spinner, Table} from "react-bootstrap";
import moment from "moment-timezone";
import {Glyph} from "../common/Glyph";
import {GlobalContext} from "../../GlobalContext";

export default class MarketingQueryResults extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);

        this.state = {
            showSaveModal: false,
            resultsetName: "",
            resultsetShared: false
        }
    }

    renderData = (data, col) => {
        if (col.type.name === "boolean") return data ? "True" : "False";
        if (col.type.name === "datetime") return data ? moment(data).format("M/D/YYYY h:mm A") : "";
        if (col.type.name === "date") return data ? moment(data).format("M/D/YYYY") : "";
        return data;
    }

    goToPage = (pageNum) => {
        this.props.setPageNum && this.props.setPageNum(pageNum);
    }

    saveResultset = () => {
        let rs = this.props.resultset;
        if (rs) {
            let name = window.prompt("Give this result set a name:");
            if (name && name.trim()) {
                let body = {id: rs.id, name};
                this.context.apiRequest("POST", `/marketingQuery/resultset/${rs.id}/save`, body);
            }
        }
    }

    render() {
        let config = this.props.config;
        let rs = this.props.resultset;
        let pageNum = this.props.pageNum || 0;
        let pageSize = this.props.pageSize || 50;

        let lastPage = rs && rs.rowCount > 0 ? Math.ceil(rs.rowCount / pageSize)-1 : 0;

        return <Container fluid>
            <Modal show={this.state.showSaveModal}>
                <Modal.Body>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({showSaveModal: false})}>
                        Cancel
                    </Button>
                    <Button variant="dark" onClick={this.onOk}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
            <Row className={"justify-content-center"}>
                <Col md={4}></Col>
                <Col md={4}>
                    {rs && rs.rowCount > 0 && <Row  className={"justify-content-center"}><Col md={"auto"}>
                    <Pagination>
                        <Pagination.First disabled={pageNum === 0} onClick={() => this.goToPage(0)}/>
                        <Pagination.Prev disabled={pageNum === 0} onClick={() => this.goToPage(pageNum > 0 ? pageNum - 1 : 0)}/>
                        <Pagination.Item disabled={true}>{this.props.pageNum + 1} of {lastPage+1}</Pagination.Item>
                        <Pagination.Next disabled={pageNum === lastPage} onClick={() => this.goToPage(pageNum < lastPage ? pageNum + 1 : lastPage)}/>
                        <Pagination.Last disabled={pageNum === lastPage} onClick={() => this.goToPage(lastPage)}/>
                    </Pagination>
                    </Col></Row>}
                </Col>
                <Col md={4} className={"text-right"}>
                    {rs && rs.rowCount > 0 && <>
                        {/*<Button variant={"secondary"} onClick={() => this.setState({showSaveModal: true})} className={"mr-2"}><Glyph name={"floppy"}/></Button>*/}
                        <Button variant={"secondary"} onClick={this.props.exportResults}><Glyph name={"download"}/></Button>
                    </>}
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Table striped bordered size={"sm"}>
                        <thead>
                            <tr>
                                {
                                    config.columns.map(c => <th key={c.key}>{c.label}</th>)
                                }
                            </tr>
                        </thead>
                        <tbody>
                        {
                            !rs && <tr>
                                <td colSpan={config.columns.length} className={"text-center"}>Click "Execute" above to run a query.</td>
                            </tr>
                        }
                        {
                            rs && rs.status === "Complete" && rs.rows && rs.rows.length > 0 && rs.rows.map(r => <tr key={r.rowNum}>
                                {
                                    config.columns.map(c => <td key={c.key+r.rowNum}>{this.renderData(r[c.key], c)}</td>)
                                }
                            </tr>)
                        }
                        {
                            rs && rs.status === "Complete" && rs.rows.length == 0 &&
                                <tr>
                                    <td colSpan={config.columns.length} colSpan={config.columns.length} className={"text-center"}>
                                        No Results
                                    </td>
                                </tr>
                        }
                        {
                            rs && rs.status === "Error" &&
                                <tr>
                                    <td colSpan={config.columns.length} colSpan={config.columns.length} className={"text-center"}>
                                        Error while running query. See logs for more details.
                                    </td>
                                </tr>
                        }
                        {
                            rs && rs.status === "Pending" &&
                                <tr style={{height: "200px"}}>
                                    <td colSpan={config.columns.length} className={"text-center"} style={{verticalAlign: "middle"}}>
                                        <Spinner animation={"border"} size={"lg"}/>
                                    </td>
                                </tr>
                        }
                        </tbody>
                    </Table>
                </Col>
            </Row>
            {rs && rs.rowCount > 0 && <Row className={"justify-content-center"}>
                <Col md={"auto"}>
                    <Pagination>
                        <Pagination.First disabled={pageNum === 0} onClick={() => this.goToPage(0)}/>
                        <Pagination.Prev disabled={pageNum === 0} onClick={() => this.goToPage(pageNum > 0 ? pageNum - 1 : 0)}/>
                        <Pagination.Item disabled={true}>{this.props.pageNum + 1} of {lastPage+1}</Pagination.Item>
                        <Pagination.Next disabled={pageNum === lastPage} onClick={() => this.goToPage(pageNum < lastPage ? pageNum + 1 : lastPage)}/>
                        <Pagination.Last disabled={pageNum === lastPage} onClick={() => this.goToPage(lastPage)}/>
                    </Pagination>
                </Col>
            </Row>}
        </Container>
    }
}